<template>
  <v-dialog :value="value" width="350" persistent>

    <v-card>

      <v-card-title>Exclusion</v-card-title>

      <v-card-text>

        <v-select v-model="form.exclusion_kind" label="Exclusion Kind" :items="exclusionKind" dense outlined hide-details class="mb-5"></v-select>

        <template v-if="form.exclusion_kind!=='none'">

          <v-select v-model="form.exclusion_length" label="Exclusion Length" :items="exclusionLength" dense outlined hide-details class="mb-5"></v-select>

          <div class="mb-5">
            <p class="mb-1 text-caption">Excluded until</p>
            <p><b>{{ form.exclude_end_date | customPlaceholder}}</b></p>
          </div>

        </template>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="save" :loading="getSaveExclusionLoading" :disabled="getSaveExclusionLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="getSaveExclusionLoading">CLOSE</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
  import moment from 'moment';
  import {mapActions, mapGetters} from 'vuex';

  export default {
    props: ['value'],

    data() {
      return {
        exclusionKind: [
          {text: 'Exclude from Credit Control', value: 'exclude'},
          {text: 'Exclude from comms only', value: 'comms'},
          {text: 'No Exclusion', value: 'none'},
        ],
        exclusionLength: [
          {text: '5 Days', value: '5'},
          {text: '10 Days', value: '10'},
          {text: '15 Days', value: '15'},
          {text: '30 Days', value: '30'},
        ],
        form: {
          exclusion_kind: '',
          exclusion_length: '',
          exclude_end_date: null
        },
        account_id: this.$route.params.id
      }
    },

    computed: {
      ...mapGetters('creditControl', ['getSaveExclusionLoading', 'getSaveExclusionError', 'getCreditControlHistory']),
    },

    watch: {
      form: {
        immediate: false,
        handler() {
          if (this.form.exclusion_kind === 'none') {
            this.form.exclusion_length = '';
            this.form.exclude_end_date = null;
          }

          if (this.form.exclusion_length) {
            this.form.exclude_end_date =  moment().add(this.form.exclusion_length, 'days').format('YYYY-MM-DD');
          }
        },
        deep: true
      }
    },

    methods: {
      ...mapActions('creditControl', ['saveExclusion', 'updateCreditControlHistoryPagination']),

      resetForm() {
        this.form.exclusion_kind = '';
        this.form.exclusion_length = '';
        this.form.exclude_end_date = null;
      }, 

      async save() {
        const data = {
          account_id: this.account_id,
          payload: {
            exclusion_kind: this.form.exclusion_kind,
            exclude_end_date: this.form.exclude_end_date
          }
        };

        await this.saveExclusion(data);

        if (!this.getSaveExclusionError) {
          this.updateCreditControlHistoryPagination({account_id: this.account_id, options: {itemsPerPage: this.getCreditControlHistory.config.paginationLimit, page: 1}});
          this.close();
        }
      },

      close() {
        this.resetForm();
        this.$emit('input', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>